import React from "react";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";

const BannerMsg = ({ type, message }) => {
  const isSuccess = type === "success";

  return (
    <div
      className={`flex items-center gap-2 p-3 mt-3 text-sm border rounded-lg ${
        isSuccess
          ? "text-green-700 bg-green-50 border-green-200"
          : "text-red-700 bg-red-50 border-red-200"
      }`}
      role="status"
    >
      {isSuccess ? (
        <CheckCircleIcon className="w-5 h-5" />
      ) : (
        <ExclamationCircleIcon className="w-5 h-5" />
      )}

      <span>{message}</span>
    </div>
  );
};

export default BannerMsg;
